module.exports = __webpack_public_path__ + "img/vol06_character_name4.8d29c14a.png";